/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Record_PaymentInputs */

const en_student_record_payment = /** @type {(inputs: Student_Record_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record payment`)
};

const he_student_record_payment = /** @type {(inputs: Student_Record_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רישום תשלום`)
};

/**
* | output |
* | --- |
* | "Record payment" |
*
* @param {Student_Record_PaymentInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_record_payment = /** @type {((inputs?: Student_Record_PaymentInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Record_PaymentInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_record_payment(inputs)
	return he_student_record_payment(inputs)
});